import React from 'react'
import { motion } from "framer-motion";
import featureThum from './../banner.png'
// import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

export default function Keyfeature() {
    const values = [
  {
    title: "Structured Approach",
    desc: "Upholding the highest standards of honesty and transparency.",
  },
  {
    title: "Strong Network",
    desc: "Continuously improving our services to meet evolving needs.",
  },
  {
    title: "Big Deal Capability",
    desc: "Prioritizing customer satisfaction at every step.",
  },
   {
    title: "Execution Focus",
    desc: "Prioritizing customer satisfaction at every step.",
  },
 
];

  return (
    <section className="relative py-16 sm:py-20 px-4 sm:px-6 bg-gr via-blue-50 to-purple-50 overflow-hidden">

      {/* Background blur */}
      <div className="absolute w-72 h-72 bg-blue-400/20 blur-3xl rounded-full top-10 left-10"></div>
      <div className="absolute w-72 h-72 bg-purple-400/20 blur-3xl rounded-full bottom-10 right-10"></div>

      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">

        {/* LEFT SIDE */}
        <div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-10">
            Key Differentiators
          </h2>

          <div className="space-y-6">
            {values.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.2, duration: 0.5 }}
                viewport={{ once: true }}
                className="group py-2 px-4  rounded-lg bg-gr backdrop-blur-lg border border-white/30 shadow-md hover:shadow-xl transition-all"
              >
                <div className="flex justify-between items-start gap-4">
                  <div>
                    <h3 className="text-lg font-semibold text-dark-gold">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-300 mt-1">
                      {item.desc}
                    </p>
                  </div>

                  {/* Arrow */}
                  <span className="text-xl text-slate-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition">
                    {/* <ArrowOutwardIcon/> */}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="relative flex justify-center"
        >
          {/* Glass circle */}
          <div className="absolute w-72 h-72 sm:w-96 sm:h-96 bg-white/30 backdrop-blur-xl rounded-full"></div>

          {/* Image */}
          <img
            src={featureThum} // replace with your image
            alt="User"
            className="relative object-cover"
          />

          {/* Floating animation */}
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ repeat: Infinity, duration: 3 }}
            className="absolute -top-4 right-10 w-6 h-6 bg-blue-500 rounded-full"
          />
        </motion.div>

      </div>
    </section>
  )
}
